import React, { useEffect, useState } from "react";
import CallLog from "./CallLog";
import SmsLog from "./SmsLog";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import useGetDeviceStatus from "../../../customHooks/getDeviceStatus";
import useTimeSupervision from "../SetRules/TimeSupervision/useTimeSupvervision";
import useLangTranslation from "../../../customHooks/languageProvider";
import Select from "react-select";
import KidImage from "../../../shared/KidImage/KidImage";
import CommonStatus from "../Common/CommonStatus";
import useDeviceStatus from "../../../customHooks/deviceStatusProvider";
import { useDashboardDataProvider } from "../../../customHooks/dashboardDataProvider";

const CallSms = () => {
  const history = useHistory();
  const { handleDeviceSelection } = useDashboardDataProvider();
  const [deviceOptions, setDeviceOptions] = useState([]);
  const { getLangTranslation } = useLangTranslation();
  const [deviceStatus, setDeviceStatus] = useState("");
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );
  const [kidData, setKidData] = useState(null);
  const [deviceId, setDeviceId] = useState(null);
  const { selectedKidId, kidDevicesList, selectedDeviceData, kidList } =
    useSelector(({ dashboard }) => dashboard);
  const { getDeviceStatus } = useGetDeviceStatus();
  const { getTimeSuperVisionData } = useTimeSupervision();

  useEffect(() => {
    if (selectedDeviceData) {
      getDeviceStatusData(selectedDeviceData?.ID);
      getTimeSuperVisionData(selectedDeviceData?.ID);
      getTimeSuperVisionData(selectedDeviceData?.ID, "UsedAppTimeDataModel");
    }
    // else {
    //     dispatch(setRuleDataSetUp(null));
    //     dispatch(setRuleUsedAppTimeDataModel(null));
    // }
  }, [selectedDeviceData]);

  useEffect(() => {
    if (selectedKidId && kidList) {
      const kid = kidList?.find((item) => item?.ID === selectedKidId);
      setKidData(kid);
    }
  }, [selectedKidId, kidList]);

  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <div
                    onClick={() => history.goBack()}
                    className="text-blue-900 fs-5"
                  >
                    <i
                      className={`${
                        lang?.isRTL === 1
                          ? "icon-arrow-right"
                          : "icon-arrow-left"
                      }`}
                    />
                  </div>
                  <h3 className="text-blue-900 mb-0">
                    {getLangTranslation(
                      "PARENT_NOTIFICATION_FILTER_CALL_AND_SMS",
                      "Calls & SMS"
                    )}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              <KidImage imageUrl={kidData?.image}  gender={kidData?.gender} />
              <div className="list-content">
                <h5 className="text-blue-900 mb-0">{kidData?.childName}</h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item content-300 w-100">
              <div className="select-with-icon">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                <Select
                  className="custom-select"
                  classNamePrefix="custom-select"
                  // placeholder="Select Device"
                  placeholder={getLangTranslation(
                    "CALL_LOG_SELECT_DEVICE",
                    "Select Device"
                  )}
                  options={deviceOptions}
                  value={
                    deviceOptions?.find((item) => item?.value === selectedDeviceData?.ID) || ""
                  }
                  onChange={handleDeviceSelection}
                  isSearchable={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <nav>
        <div className="nav nav-tabs" id="nav-tab" role="tablist">
          <button
            className="nav-link active"
            id="callLogTab"
            data-bs-toggle="tab"
            data-bs-target="#CallLog"
            type="button"
            role="tab"
            aria-controls="CallLog"
            aria-selected="false"
          >
            {getLangTranslation("CALL_LOG_PAGE_TITLE", "Call Log")}
          </button>
          <button
            className="nav-link"
            id="smsLogTab"
            data-bs-toggle="tab"
            data-bs-target="#smsLog"
            type="button"
            role="tab"
            aria-controls="smsLog"
            aria-selected="true"
          >
            {getLangTranslation("SMS_LOG_PAGE_TITLE", "SMS Log")}
          </button>
        </div>
      </nav>
      <div className="card border-0">
        <div className="card-body">
          <div className="tab-content" id="nav-tabContent">
            <div
              className="tab-pane fade show active"
              id="CallLog"
              role="tabpanel"
              aria-labelledby="callLogTab"
            >
              <CallLog deviceId={selectedDeviceData?.ID} selectedKidId={selectedKidId} />
            </div>
            <div
              className="tab-pane fade"
              id="smsLog"
              role="tabpanel"
              aria-labelledby="smsLogTab"
            >
              <SmsLog deviceId={selectedDeviceData?.ID} selectedKidId={selectedKidId} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CallSms;
